import Vue from 'vue';

const state = {
    settings:{
        company:{}
    },
    isDonwloadingCompanySettings: false,
    skipStartingTasks: false,
    company:{},
    productsContent: {},
};

const getters = {
    getCompanyInfo: (state) => state.company,
    getIsDonwloadingCompanySettings: (state) => state.isDonwloadingCompanySettings,
    getCompanySettings: (state) => state.settings,
    getSkipStartTasks: (state) => state.skipStartingTasks,
    getShowInvoiceOption: (state, rootState) => {
        return rootState.getCompanySettings.settingsPresets && rootState.getCompanySettings.settingsPresets.hasInvoiceSystem && rootState.getCompanySettings.settingsPresets.invoiceSystem.isActive
    }
};

const actions = {
    initCompany ({commit, rootState, dispatch}) {
        return dispatch('initSettings').then(initSettingsResponse => {

            commit('GET_COMPANY_INFO', initSettingsResponse);

            return initSettingsResponse;
        })

    },

    initSettings ({state, commit, rootState, dispatch}) {
        state.isDonwloadingCompanySettings = true
        // if(!rootState.user.account.supplierId){
        //     return false
        // }

            dispatch('refreshAccountData').then(refreshAccountDataResponse => {
                return axios.get('/api/supplier/GetSupplier', {
                    params: {
                        supplierid: rootState.user.account.supplierId
                    }
                }).then(getSupplierResponse => {
                    state.isDonwloadingCompanySettings = false
                    if (getSupplierResponse && getSupplierResponse.status === 200 && getSupplierResponse.data) {
                        commit('UPDATE_SETTINGS_COMPANY', getSupplierResponse.data);
                        dispatch('checkAppVersion', {
                            forceRefresh: true
                        }).then(checkAppVersionResponse => {
                            return getSupplierResponse
                        })

                    }

                }).catch(err => {
                    state.isDonwloadingCompanySettings = false
                })
            })

    },

    async downloadPersonalizedServices ({commit, rootState, dispatch}) {
        dispatch('downloadSalesChannels')
    },

    saveSettingsCompany ({state, rootState}, data){
        let dataToSend = {agentId:0, by:'' , supplier: data}

        axios.post('/api/supplier/editsupplier', dataToSend)
        .then((response) =>{
          console.log('response:');
          console.log(response);
          if(response && response.status === 200){
            Vue.toasted.success('Settings Saved');
            //update top dropdown with the new comapny name
            rootState.user.account.supplier.brand = data.brand;
          }
        })
        .catch(function(){
          Vue.tosted.error('error');
        });
    },

    saveSettingsPresets ({state, rootState}, data){

        return axios.post('/api/supplier/SetPresets', {
            supplierid: rootState.user.account.supplierId,
            presets: data
        })
        .then((response) =>{
            if(response && response.status === 200){
                Vue.toasted.success('Settings Saved');
                //update top dropdown with the new comapny name
            }
        })
        .catch(function(){
            Vue.tosted.error('error');
        });
    },

    initOldProducts: ({ dispatch, commit, getters }, data) => {
        // This is an example of an old dummy product for reference
        var p = {
            id: 1,
            category: { id: 1, label: 'Sailing & water' },
            code: 'OGC',
            name: 'Ophelia Golden Cruise',
            color: 'color-1',
            description: 'Coastline tour.',
            imageUrl: '/static/images/product1.jpg',
            thumbUrl: '/static/images/product1_small.jpg',
            prices: [
                { value: 50, type: { id: 1, label: 'By person' }, person: { id: 1, label: 'Adult' } },
                { value: 20, type: { id: 1, label: 'By person' }, person: { id: 2, label: 'Children' } },
                { value: 10, type: { id: 1, label: 'By person' }, person: { id: 3, label: 'Infant' } },
            ],
            taxes: {
                adl: 0.25,
                chl: 0.15,
                inf: 0,
            },
            commission: 0.2,
            deposit: { id: 1, label: 'Fixed amount (total)', name: 'Amount', symbol: '€', value: 10 },
            promos: [
                {
                    id: 1,
                    title: 'Promo',
                    token: 'PROMO10',
                    from: '2017-06-01 09:00:00',
                    until: '2018-07-01 09:00:00',
                    type: 'percentage',
                    value: 10
                }
            ],
            extras: [
                {
                    item: {
                        id: 4,
                        name: 'Fishing license',
                        description: 'Fishing license that allows to capture fish till 12kg',
                        priceType: { id: 1, label: 'Per order' },
                        priceTotal: 5,
                        capacityType: '',
                        capacity: null,
                        tax: { id: 2, label: 'IVA - 23%', value: 0.23 },
                        usedBy: 1,
                        passengerType: { }
                    },
                    isMandatory: false,
                    priceIncluded: false
                },
            ],
            active: true,
            capacity: 12,
            salesPermissions: {},
            schedules: [],
            resources: [
                {
                    item: {
                        id: 1,
                        name: 'Corona',
                        price: 20.00,
                        code: 'CO',
                        type: { id: 3, label: 'Boat' },
                        availability: 20,
                        availabilityType: 'unit',
                        shared: false,
                        private: false,
                        status: true
                    },
                    isFavorite: true,
                },
            ],
            isPrivate: false,
            disabledDiscount: false,
            allowRules: true,
            isFixedPrice: true,
            tax: { id: 1, label: '23%', value: 0.23 },
            includeTaxes: true,
            visibility: { id: 1, label: 'All customers can see and book this product online' },
            salesPermissionsTeam: true,
            salesPermissionsWebsite: true,
            salesPermissionsAgents: true,
            salesPermissionsAgentsCustom: false,
            type: { id: 1, label: 'This is a regular tour starting at fixed times' },
            dateFrom: '2018-01-01',
            dateTo: '2018-12-31',
            duration: { id: 1, label: '01h00', value: 1 },
            hasManualConfirmation: true,
            payment: { id: 1, label: 'Require payment of a deposit' },
        }
    },

    updateCompany: ({commit}, newCompany) => {
        commit('UPDATE_COMPANY', newCompany);
    },

    skipStartingTasks: ({commit}) => {
        commit('SET_SKIP_STARTING_TASKS');
    },
};

const mutations = {
    UPDATE_SETTINGS_COMPANY: (state, data) => {
      state.settings = data;
    },

    GET_COMPANY_INFO: (state, data) => {
        state.company = data;
    },

    UPDATE_COMPANY: (state, data) => {
        state.company = data;
    },

    SET_SKIP_STARTING_TASKS: (state) => {
        console.log('setting: skipStartingTasks TRUE');
        state.skipStartingTasks = true;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js